import React from "react";
import { Helmet } from "react-helmet-async";
import "./about.css"; // For About-specific styling
import "../HomePage/home.css";
import Header from "../Navigation/header";
import Footer from "../Navigation/footer";
import TopSection from "./TopSection";
import Authors from "./Authors";
import Partners from "./Partners";
import Team from "./Team";

const About = () => {
  return (
    <>
     <Helmet>
        <title>About CWPC | Catastrophic Wildfire Prevention Consortium</title>

        <meta
          name="description"
          content="Learn about the Catastrophic Wildfire Prevention Consortium and our mission to reduce wildfire risk through collaboration and planning."
        />

        <link
          rel="canonical"
          href="https://preventwildfire.world/about"
        />

        <meta property="og:type" content="website" />
        <meta
          property="og:site_name"
          content="Catastrophic Wildfire Prevention Consortium"
        />
        <meta property="og:title" content="About CWPC" />
        <meta
          property="og:description"
          content="Who we are and how we work to prevent catastrophic wildfires."
        />
        <meta
          property="og:url"
          content="https://preventwildfire.world/about"
        />
        <meta
          property="og:image"
          content="https://preventwildfire.world/assets/og-default.jpg"
        />
      </Helmet>
      <div className="about-content">
        <TopSection />
        <Authors />
        <Partners />
        <Team />
      </div>
    </>
  );
};

export default About;
